import type { FC, ReactElement } from 'react';

import { Navigate } from 'react-router-dom';

import { useAppSelector } from '@app/store/store';
import { selectIsAuthenticated } from '@features/authentication/store/authentication.slice';

/**
 * Guards routes that only make sense for anonymous users (e.g. the login screen). If the session
 * is already authenticated — including when another tab logs in and broadcasts `LOGIN` to a tab
 * parked here — the user is sent straight into the app instead of staring at a login form.
 */
export const PublicOnlyRoute: FC<{ children: ReactElement }> = ({ children }) => {
  const isAuthenticated = useAppSelector(selectIsAuthenticated);

  if (isAuthenticated) {
    return <Navigate to="/" replace data-testid="public-only-navigate" />;
  }

  return children;
};
